export default "__VITE_ASSET__BiCtt0Df__"